import React from "react";

import "../styles.scss";
import "../scripts";

import {
  widgetBlock,
  KameleonElement,
  getDefaultProps,
  BlockType,
} from "@kameleon-core/lib";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { PlaceholderType, layoutOptions } from "./types/prop-types";

export const Placeholder = widgetBlock<PlaceholderType>(
  BlockType.NavWidget,
  ({ text }: PlaceholderType) => (
    <div className="nav-widget-placeholder-lorum-ipsum-v1">{text}</div>
  )
);

Placeholder.defaultProps = getDefaultProps<PlaceholderType>(defaults);

export const Element: KameleonElement = {
  component: Placeholder,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
